/*! video-stream.js */

/**
 * @description BMMR VideoStream object
 * @class VideoStream
 */
class VideoStream {

    /**
     * @constructs VideoStream
     * @param {?string} video_codec
     * @param {?string} muxing_format
     * @param {?string} video_bitrate
     * @param {?string} audio_codec
     * @param {?string} audio_bitrate
     * @param {?object} profile
     * @param {?string} stream_type
     * @param {?string} url
     * @param {?string} height
     * @param {?string} width
     * @param {?number} file_size
     * @param {?number} percent
     *
     */
    /* eslint-disable camelcase */
    constructor({
        video_codec = null,
        muxing_format = null,
        video_bitrate = 0,
        audio_codec = null,
        audio_bitrate = null,
        profile = null,
        stream_type = null,
        url = null,
        height = null,
        width = null,
        file_size = null,
        percent = null,
        cedexis_platform = null
    }) {
        this.videoCodec = video_codec;
        this.videoBitrate = video_bitrate ? parseInt(video_bitrate, 10) : video_bitrate;
        this.audioCodec = audio_codec;
        this.audioBitrate = audio_bitrate ? parseInt(audio_bitrate, 10) : audio_bitrate;
        this.muxingFormat = muxing_format;
        this.profile = profile;
        this.streamType = stream_type;
        this.url = url;
        this.height = height ? parseInt(height, 10) : height;
        this.width = width ? parseInt(width, 10) : width;
        this.fileSize = file_size ? parseInt(file_size, 10) : file_size;
        this.percent = percent ? parseInt(percent, 10) : percent;
        this.cedexisPlatform = cedexis_platform;
    }

    /* eslint-enable camelcase */

    /**
     * @method
     * @returns {string|null}
     */
    getVideoCodec() {
        return this.videoCodec;
    }

    /**
     * @method
     * @returns {string|null}
     */
    getMuxingFormat() {
        return this.muxingFormat;
    }

    /**
     * @method
     * @returns {number|null}
     */
    getVideoBitrate() {
        return this.videoBitrate;
    }

    /**
     * @method
     * @returns {string|null}
     */
    getAudioCodec() {
        return this.audioCodec;
    }

    /**
     * @method
     * @returns {number|null}
     */
    getAudioBitrate() {
        return this.audioBitrate;
    }

    /**
     * @method
     * @returns {object|null}
     */
    getProfile() {
        return this.profile;
    }

    /**
     * @method
     * @returns {string|null}
     */
    getStreamType() {
        return this.streamType;
    }

    /**
     * @method
     * @returns {string|null}
     */
    getUrl() {
        return this.url;
    }

    /**
     * @method
     * @returns {number|null}
     */
    getHeight() {
        return this.height;
    }

    /**
     * @method
     * @returns {number|null}
     */
    getWidth() {
        return this.width;
    }

    /**
     * @method
     * @returns {number|null}
     */
    getFileSize() {
        return this.fileSize;
    }

    /**
     * @method
     * @returns {number|null}
     */
    getPercent() {
        return this.percent;
    }

    /**
     * @method
     * @returns {boolean}
     */
    isSecure() {
        return this.url && this.url.slice(0, 5) === "https";
    }

    /**
     * @method
     * @returns {object}
     */
    toJSON() {
        return {
            "url": this.url,
            "type": this.streamType,
            "bitrate": this.videoBitrate,
            "percent": this.percent
        };
    }
}

export default VideoStream;
